<app-loader *ngIf="showLoader()"></app-loader>
<div class="container">
  <!-- HEADER -->
  <div class="affiliation-head">
    <button class="btn reset-btn" (click)="goBack()" aria-label="Go Back">
      <div class="label-img">
        <i class="bi bi-arrow-left-circle icon fs-4 btn-icon"></i>
        Back
      </div>
    </button>
    <label>
      <input type="radio" name="view" checked (change)="setView('rollup')" />
      Affiliations (Roll-Up)
    </label>

    <label style="margin-left: 20px">
      <input
        type="radio"
        name="view"
        (change)="setView('rolldown')"
        [disabled]="isHcpType"
      />
      Affiliations (Roll-Down)
    </label>
    <span
  class="tooltip-wrapper"
  [class.show-tooltip]="isHcpType && !isParentRowSelected"
  [attr.data-tooltip]="
    isHcpType && !isParentRowSelected
      ? 'Select an account from Parent affiliations grid to view Graph'
      : null
  "
>
  <button
    class="btn reset-btn push-right"
    aria-label="Go To Graph"
    (click)="goToGraph()"
    [disabled]="isHcpType && !isParentRowSelected"
  >
    <div class="label-img">
      <i class="bi bi-diagram-2"></i>
      Graphical Representation
    </div>
  </button>
</span>
  </div>

  <!-- ================= ROLL-UP ================= -->
  <div [hidden]="viewMode !== 'rollup'">
    <div class="affiliation-body">
      <p class="main-heading">Sanofi | Customer Research Tool</p>

      <!-- RCM -->
      <div class="card">
        <p class="affiliation-text">RCM Mastered Profile</p>

        <div class="table-wrapper">
          <div class="table-header cols-12">
            <span>RCM ID</span>
            <span>Name</span>
            <span>Address</span>
            <span>City</span>
            <span>State</span>
            <span>Zip</span>
            <span>USPS Flag</span>
            <span>DEA</span>
            <span>HIN</span>
            <span>NPI</span>
            <span>340B</span>
            <span>SLN</span>
          </div>
          <div *ngIf="rcmProfile?.length; else noRcmData">
            <div class="table-body cols-12" *ngFor="let row of rcmProfile">
              <span>
  <a
    href="javascript:void(0)"
    class="clickable-cell"
    (click)="openResultProfile(row.rcm_id)"
  >
    {{ row.rcm_id }}
  </a>
</span>
              <span>{{ row.name }}</span>
              <span>{{ row.address_line_1 }}</span>
              <span>{{ row.city }}</span>
              <span>{{ row.state }}</span>
              <span>{{ row.zip }}</span>
              <span>{{ row.usps_status }}</span>
              <span>{{ row.dea_num }}</span>
              <span>{{ row.hin_no }}</span>
              <span>{{ row.npi }}</span>
              <span>{{ row.id_340b }}</span>
              <span>{{ row.sln }}</span>
            </div>
          </div>
          <ng-template #noRcmData>
            <div class="no-data">No Data Available</div>
          </ng-template>
        </div>
      </div>

      <!-- PARENT -->
      <div class="card">
        <p class="affiliation-text">Parent Affiliations</p>

        <div class="table-wrapper">
          <div class="table-header cols-9">
            <span>CUST ID</span>
           <span
  *ngIf="isHcpType; else normalLevelHeader"
  (click)="sortParentAffiliationByLevel()"
  style="cursor: pointer"
>
  Level
  <i
    class="bi"
    [ngClass]="{
      'bi-caret-up-fill': parentLevelSortDirection === 'asc',
      'bi-caret-down-fill': parentLevelSortDirection === 'desc'
    }"
  ></i>
</span>

<ng-template #normalLevelHeader>
  <span>Level</span>
</ng-template>
            <span>Organization Name</span>
            <span>Relationship Category</span>
            <span>Relationship Sub-Category</span>
            <span>HCA Address</span>
            <span>SHIFT ID</span>
            <span>RMUS ID</span>
            <span>SAP ID</span>
          </div>
          <div *ngIf="parentAffiliation?.length; else noParentData">
            <div
              class="table-body cols-9"
              *ngFor="let row of paginatedParentAffiliation"
              (click)="onParentRowClick(row)"
              [class.selected-row]="selectedParentRow === row"
            >
              <span>
  <a
    href="javascript:void(0)"
    class="clickable-cell"
    (click)="openResultProfile(row.parent_hca_rcm_id)"
  >
    {{ row.parent_hca_rcm_id }}
  </a>
</span>
              <span>{{ row.parent_level }}</span>
              <span>{{ row.org_name }}</span>
              <span>{{ row.relationship_category }}</span>
              <span>{{ row.relationship_sub_category }}</span>
              <span>{{ row.parent_hca_address }}</span>
              <span>{{ row.shift_id }}</span>
              <span>{{ row.rmus_id }}</span>
              <span>{{ row.sap_id }}</span>
            </div>
          </div>
         <ng-template #noParentData>
  <div
    *ngIf="showNoAffiliationMessage; else defaultNoData"
    class="no-data"
  >
    No affiliation data from IQVIA is currently available for this account.
  </div>

  <ng-template #defaultNoData>
    <div class="no-data">
      {{
        serchedAccountType === 'L1'
          ? 'No parent affiliations available. This account is at L1 (top level in the HCA hierarchy).'
          : 'No Data Available'
      }}
    </div>
  </ng-template>
</ng-template>
        </div>
        <mat-paginator
  *ngIf="parentAffiliation?.length"
  [length]="parentAffiliation?.length || 0"
  [pageSize]="parentPageSize"
  [pageSizeOptions]="[5, 10, 25]"
  (page)="onParentPageChange($event)"
>
</mat-paginator>
      </div>
    </div>
  </div>

  <!-- ================= ROLL-DOWN ================= -->
  <div [hidden]="viewMode !== 'rolldown'">
    <div class="affiliation-body">
      <p class="main-heading">Sanofi | Customer Research Tool</p>

      <!-- ✅ HCP -->
      <div class="card">
        <p class="affiliation-text">HCP Child Affiliations</p>

        <div class="table-wrapper">
          <div class="table-header cols-9">
            <span>CUST ID</span>
            <span>First Name</span>
            <span>Middle Name</span>
            <span>Last Name</span>
            <span>Relationship Category</span>
            <span>Relationship Sub-Category</span>
            <span>HCP Address</span>
            <span>Prof Designation</span>
            <span>DEA Number</span>
          </div>

          <div *ngIf="paginatedHcpChildAffiliation?.length; else noHcpData">
            <div
              class="table-body cols-9"
              *ngFor="let row of paginatedHcpChildAffiliation"
            >
              <span>
  <a
    href="javascript:void(0)"
    class="clickable-cell"
    (click)="openResultProfile(row.target_hcp_rcm_id)"
  >
    {{ row.target_hcp_rcm_id }}
  </a>
</span>
              <span>{{ row.target_hcp_first_name }}</span>
              <span>{{ row.target_hcp_middle_name }}</span>
              <span>{{ row.target_hcp_last_name }}</span>
              <span>{{ row.relationship_category }}</span>
              <span>{{ row.relationship_sub_category }}</span>
              <span>{{ row.target_hcp_address }}</span>
              <span>{{ row.target_hcp_designation }}</span>
              <span>{{ row.target_hcp_dea_number }}</span>
            </div>
          </div>
          <ng-template #noHcpData>
            <div class="no-data">No Data Available</div>
          </ng-template>
        </div>

        <!-- ✅ NEW PAGINATOR -->
        <mat-paginator
          *ngIf="hcpChildAffiliations?.length"
          [length]="hcpChildAffiliations?.length || 0"
          [pageSize]="hcpPageSize"
          [pageSizeOptions]="[5, 10, 25]"
          (page)="onHcpPageChange($event)"
        >
        </mat-paginator>
      </div>

      <!-- ✅ HCA -->
      <div class="card">
        <p class="affiliation-text">HCA Child Affiliations</p>

        <div class="table-wrapper">
          <div class="table-header cols-9">
            <span>CUST ID</span>
            <span>Level</span>
            <span>Organization Name</span>
            <span>Relationship Category</span>
            <span>Relationship Sub-Category</span>
            <span>HCA Address</span>
            <span>SHIFT ID</span>
            <span>RMUS ID</span>
            <span>SAP ID</span>
          </div>
          <div *ngIf="paginatedHcaChildAffiliation?.length; else noHcaData">
            <div
              class="table-body cols-9"
              *ngFor="let row of paginatedHcaChildAffiliation"
            >
              <span>
  <a
    href="javascript:void(0)"
    class="clickable-cell"
    (click)="openResultProfile(row.target_hca_rcm_id)"
  >
    {{ row.target_hca_rcm_id }}
  </a>
</span>
              <span>{{ row.target_level }}</span>
              <span>{{ row.target_hca_name }}</span>
              <span>{{ row.relationship_category }}</span>
              <span>{{ row.relationship_sub_category }}</span>
              <span>{{ row.target_hca_address }}</span>
              <span>{{ row.shift_id }}</span>
              <span>{{ row.rmus_id }}</span>
              <span>{{ row.sap_id }}</span>
            </div>
          </div>
          <ng-template #noHcaData>
             <div class="no-data">
    {{
      serchedAccountType === 'L3'
        ? 'No child affiliations available. This account is at L3 (lowest level in HCA hierarchy).'
        : 'No Data Available'
    }}
  </div>
          </ng-template>
        </div>

        <mat-paginator
          *ngIf="hcaChildAffiliation?.length"
          [length]="hcaChildAffiliation?.length || 0"
          [pageSize]="hcaPageSize"
          [pageSizeOptions]="[5, 10, 25]"
          (page)="onHcaPageChange($event)"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
